import { NgZone, Injectable, Injector, NgModule, Self } from '@angular/core';
import { Store } from '@ngxs/store';
import { __awaiter } from 'tslib';
import { isObservable } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxsDispatchPluginModuleNotImported extends Error {
    constructor() {
        super('"NgxsDispatchPluginModule" is not imported.');
    }
}
class StaticInjector {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        StaticInjector.injector = injector;
    }
    /**
     * @return {?}
     */
    static getStore() {
        if (this.injector === null) {
            throw new NgxsDispatchPluginModuleNotImported();
        }
        return this.injector.get(Store);
    }
    /**
     * @return {?}
     */
    static getZone() {
        if (this.injector === null) {
            throw new NgxsDispatchPluginModuleNotImported();
        }
        return this.injector.get(NgZone);
    }
}
StaticInjector.ɵfac = function StaticInjector_Factory(t) { return new (t || StaticInjector)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
StaticInjector.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: StaticInjector, factory: StaticInjector.ɵfac });
StaticInjector.injector = null;
/** @nocollapse */
StaticInjector.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StaticInjector, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxsDispatchPluginModule {
    /**
     * @param {?} staticInjector
     */
    constructor(staticInjector) {
        this.staticInjector = staticInjector;
    }
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: NgxsDispatchPluginModule,
            providers: [StaticInjector]
        };
    }
}
NgxsDispatchPluginModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxsDispatchPluginModule });
NgxsDispatchPluginModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxsDispatchPluginModule_Factory(t) { return new (t || NgxsDispatchPluginModule)(ɵngcc0.ɵɵinject(StaticInjector, 2)); } });
/** @nocollapse */
NgxsDispatchPluginModule.ctorParameters = () => [
    { type: StaticInjector, decorators: [{ type: Self }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxsDispatchPluginModule, [{
        type: NgModule
    }], function () { return [{ type: StaticInjector, decorators: [{
                type: Self
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This class is used as a default action when the user
 * doesn't pass any custom action as an argument
 * @template T
 */
class DispatchAction {
    /**
     * @param {?=} payload
     */
    constructor(payload) {
        this.payload = payload;
    }
}
DispatchAction.type = null;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} target
 * @return {?}
 */
function isPromise(target) {
    return target instanceof Promise;
}
/**
 * @param {?=} descriptor
 * @return {?}
 */
function isMethodDecorator(descriptor) {
    return !!descriptor && descriptor.hasOwnProperty('value');
}
/**
 * @param {?} event
 * @return {?}
 */
function eventIsPlainObject(event) {
    return event.constructor === Object;
}
/**
 * @param {?} events
 * @return {?}
 */
function composeEventsThatMayDiffer(events) {
    /** @type {?} */
    const length = events.length;
    /** @type {?} */
    const composed = new Array(length);
    for (let i = 0; i < length; i++) {
        /** @type {?} */
        const event = events[i];
        if (eventIsPlainObject(event)) {
            DispatchAction.type = event.type;
            composed[i] = new DispatchAction(event.payload);
        }
        else {
            composed[i] = event;
        }
    }
    return composed;
}
/**
 * @template T
 * @param {?} value
 * @return {?}
 */
function flatten(value) {
    return Array.isArray(value) ? value : [value];
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} events$
 * @param {?} zonedDispatchFactory
 * @return {?}
 */
function unwrapObservable(events$, zonedDispatchFactory) {
    events$.subscribe((/**
     * @param {?} events
     * @return {?}
     */
    (events) => {
        zonedDispatchFactory(events);
    }));
    return events$;
}
/**
 * @param {?} promisedEvents
 * @param {?} zonedDispatchFactory
 * @return {?}
 */
function unwrapPromise(promisedEvents, zonedDispatchFactory) {
    return __awaiter(this, void 0, void 0, function* () {
        /** @type {?} */
        const events = yield promisedEvents;
        zonedDispatchFactory(events);
        return events;
    });
}
/**
 * @param {?} event
 * @param {?} dispatchFactory
 * @param {?} zone
 * @return {?}
 */
function distributeEvents(event, dispatchFactory, zone) {
    /** @type {?} */
    const zonedDispatchFactory = (/**
     * @param {?} events
     * @return {?}
     */
    (events) => {
        zone.run((/**
         * @return {?}
         */
        () => dispatchFactory(events)));
    });
    if (isObservable(event)) {
        return unwrapObservable(event, zonedDispatchFactory);
    }
    if (isPromise(event)) {
        return unwrapPromise(event, zonedDispatchFactory);
    }
    return zonedDispatchFactory(event);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} events
 * @param {?} store
 * @return {?}
 */
function dispatch(events, store) {
    /** @type {?} */
    const flattened = flatten(events);
    /** @type {?} */
    const composed = composeEventsThatMayDiffer(flattened);
    store.dispatch(composed);
}
/**
 * @return {?}
 */
function Dispatch() {
    return (/**
     * @param {?} target
     * @param {?} key
     * @param {?=} descriptor
     * @return {?}
     */
    (target, key, descriptor) => {
        /** @type {?} */
        let originalValue = (/** @type {?} */ (null));
        /**
         * @this {?}
         * @return {?}
         */
        function wrapped() {
            /** @type {?} */
            const event = originalValue.apply(this, arguments);
            /** @type {?} */
            const zone = StaticInjector.getZone();
            /** @type {?} */
            const store = StaticInjector.getStore();
            /** @type {?} */
            const dispatchFactory = (/**
             * @param {?} events
             * @return {?}
             */
            (events) => dispatch(events, store));
            return zone.runOutsideAngular((/**
             * @return {?}
             */
            () => distributeEvents(event, dispatchFactory, zone)));
        }
        if (isMethodDecorator(descriptor)) {
            originalValue = (/** @type {?} */ (descriptor.value));
            descriptor.value = wrapped;
        }
        else {
            Object.defineProperty(target, key, {
                set: (/**
                 * @param {?} value
                 * @return {?}
                 */
                (value) => (originalValue = value)),
                get: (/**
                 * @return {?}
                 */
                () => wrapped)
            });
        }
    });
}

export { Dispatch, DispatchAction, NgxsDispatchPluginModule, StaticInjector as ɵa };

//# sourceMappingURL=ngxs-labs-dispatch.js.map